'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { NavValues } from './types';
import { calculateNav } from './calculations';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['nav'];
}

export default function NavCalculator({ translations }: Props) {
  const [values, setValues] = useState<NavValues>({
    totalAssets: 1000000,  // 1 million SEK default
    totalLiabilities: 300000,  // 300k SEK default
    outstandingShares: 100000,  // 100k shares default
  });

  const handleValuesChange = (field: keyof NavValues, value: number) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateNav(values, translations), [values, translations]);

  return (
    <section id="nav-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
            <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
          <ResultsDisplay result={result} translations={translations} />
        </div>
      </div>
    </section>
  );
}
